export default "__VITE_ASSET__D6Au5vwZ__"